import { render, staticRenderFns } from "./AddonConfirmationModal.vue?vue&type=template&id=3fb1b4e1&scoped=true&"
import script from "./AddonConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./AddonConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddonConfirmationModal.vue?vue&type=style&index=0&id=3fb1b4e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb1b4e1",
  null
  
)

export default component.exports